import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootStateOrAny } from "react-redux";
import { getLoggedUserDistroToken } from "shared/service/StrmService";

export type ArtistState = {
  artists: {
    artistaSelecionado: {};
    distroToken: string | null;
  };
};

export const getUserDistroToken = createAsyncThunk(
  "artists/GetUserDistroToken",
  async () => {
    const response: any = await getLoggedUserDistroToken();
    return response?.response?.tokens?.[0]?.token;
  }
);

export const artistasSlice = createSlice({
  name: "artists",
  initialState: {
    artistaSelecionado: {},
    distroToken: null,
    loadingDistroToken: false,
  },
  reducers: {
    selectArtist: (state, action) => {
      state.artistaSelecionado = action.payload;
    },
  },
  extraReducers: {
    [getUserDistroToken.fulfilled.type]: (state, action) => {
      if (action.payload) {
        state.distroToken = action.payload;
      }
      state.loadingDistroToken = false;
    },
    [getUserDistroToken.pending.type]: (state) => {
      state.loadingDistroToken = true;
    },
    [getUserDistroToken.rejected.type]: (state) => {
      state.loadingDistroToken = false;
    },
  },
});

export const { selectArtist } = artistasSlice.actions;

export const artistaSelecionado = (state: RootStateOrAny) =>
  state.artistaSelecionado;

export default artistasSlice.reducer;
